/**
 * The decorative ✦ and ✚ sparkles sprinkled near the title of a Dessinée fiche.
 * Positions match the prototype exactly.
 */
export function Sparkles() {
  return (
    <>
      <span
        aria-hidden
        className="absolute pointer-events-none font-caveat"
        style={{ top: 18, left: 30, fontSize: 22, color: '#e89a3f', opacity: 0.85 }}
      >
        ✦
      </span>
      <span
        aria-hidden
        className="absolute pointer-events-none font-caveat"
        style={{ top: 42, left: 60, fontSize: 14, color: '#e89a3f', opacity: 0.85 }}
      >
        ✦
      </span>
      <span
        aria-hidden
        className="absolute pointer-events-none font-caveat"
        style={{ top: 24, right: 36, fontSize: 18, color: '#e89a3f', opacity: 0.85 }}
      >
        ✚
      </span>
      <span
        aria-hidden
        className="absolute pointer-events-none font-caveat"
        style={{ top: 48, right: 64, fontSize: 14, color: '#e89a3f', opacity: 0.85 }}
      >
        ✦
      </span>
    </>
  );
}
